import { bindWhenPlatform } from '../../../Socket/socketActionCreator';
import { apply, fork, put, takeEvery } from 'redux-saga/effects';
import {
	ClearPackageData,
	ClearPackageDataFailed,
	ClearPackageDataSucceeded,
	InstallPackage,
	InstallPackageFailed,
	InstallPackageSucceeded,
	StopPackage,
	StopPackageFailed,
	StopPackageSucceeded,
} from '@signageos/actions/dist/Device/Package/devicePackageActions';
import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import { IResponsibilities } from '../../../Feature/Responsibilities';
import Responsibility from '../../../Feature/Responsibility';
import { whenCapable } from '../../../Feature/capable';
import { withDependencies } from '../../../DI/dependencyInjection';

function* installPackageCallback(managementDriver: IManagementDriver, staticBaseUrl: string, action: InstallPackage) {
	try {
		yield apply(managementDriver, managementDriver.packageInstall, [staticBaseUrl!, action.packageName, action.version, action.build!]);
		yield put({
			type: InstallPackageSucceeded,
			uid: action.uid,
		} as InstallPackageSucceeded);
	} catch (error) {
		console.error('installPackageSaga', error);
		yield put({
			type: InstallPackageFailed,
			uid: action.uid,
		} as InstallPackageFailed);
	}
}

export function* installPackageSaga(responsibilities: IResponsibilities) {
	if (!responsibilities.has(Responsibility.PACKAGES)) {
		return;
	}

	yield bindWhenPlatform(InstallPackage);

	yield fork(
		whenCapable(
			ManagementCapability.PACKAGE_INSTALL,
			withDependencies(['managementDriver', 'staticBaseUrl'], function* ({ managementDriver, staticBaseUrl }) {
				yield takeEvery(InstallPackage, installPackageCallback, managementDriver, staticBaseUrl);
			}),
		),
	);
}

function* stopPackageCallback(managementDriver: IManagementDriver, action: StopPackage) {
	try {
		yield apply(managementDriver, managementDriver.packageStop, [action.packageName]);
		yield {
			type: StopPackageSucceeded,
			uid: action.uid,
		};
	} catch (error) {
		console.error('stopPackageSaga', error);
		yield {
			type: StopPackageFailed,
			uid: action.uid,
		};
	}
}

export function* stopPackageSaga(responsibilities: IResponsibilities) {
	if (!responsibilities.has(Responsibility.PACKAGES)) {
		return;
	}

	yield bindWhenPlatform(StopPackage);

	yield fork(
		whenCapable(
			ManagementCapability.STOP_PACKAGE,
			withDependencies(['managementDriver'], function* ({ managementDriver }) {
				yield takeEvery(StopPackage, stopPackageCallback, managementDriver);
			}),
		),
	);
}

function* clearPackageDataCallback(managementDriver: IManagementDriver, action: ClearPackageData) {
	try {
		yield apply(managementDriver, managementDriver.packageClearData, [action.packageName]);
		yield {
			type: ClearPackageDataSucceeded,
			uid: action.uid,
		};
	} catch (error) {
		console.error('slearPackageDataSaga', error);
		yield {
			type: ClearPackageDataFailed,
			uid: action.uid,
		};
	}
}

export function* clearPackageDataSaga(responsibilities: IResponsibilities) {
	if (!responsibilities.has(Responsibility.PACKAGES)) {
		return;
	}

	yield bindWhenPlatform(ClearPackageData);

	yield fork(
		whenCapable(
			ManagementCapability.CLEAR_PACKAGE_DATA,
			withDependencies(['managementDriver'], function* ({ managementDriver }) {
				yield takeEvery(ClearPackageData, clearPackageDataCallback, managementDriver);
			}),
		),
	);
}
